import axios from 'axios';
import API from '../../config/api';

import { FILL_LIST } from './mutations-types';

export default {
  async getList({ commit }) {
    try {
      const result = (await API.get('/documents/getList')).data.data;
      commit(FILL_LIST, result);
    } catch (err) {
      console.log(err);
    }
  },
  async downloadDocument({ dispatch }, params) {
    try {
      await dispatch('authorization/checkIfUserSessionExists', {}, { root: true });
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/document/downloadDocument`,
        params,
        {
          responseType: 'arraybuffer',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': true,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
          },
          withCredentials: true,
        },
      );
      return result;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async acceptContract({ dispatch }, params) {
    try {
      await dispatch('authorization/checkIfUserSessionExists', {}, { root: true });
      const result = await axios.patch(
        `${process.env.VUE_APP_API_URL}/document/acceptContract`,
        params,
        {
          responseType: 'arraybuffer',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': true,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
          },
          withCredentials: true,
        },
      );
      return result;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
};
